import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'createRange' })
export class CreateRangePipe implements PipeTransform {
  transform(value: number): number[] {
    return Array.from({ length: value }, (_, i) => i);
  }
}